import { useContext } from 'react';
import { TokenContext } from '../context/token-context';

/** Returns the access token resolved by TokenGate, or null if not yet available. */
export function useToken(): string | null {
  return useContext(TokenContext);
}
